import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Plan } from "@/types/plans";

interface PendingUpgrade {
  plan: Plan;
  isUpgrade: boolean;
}

interface UpgradeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  pendingUpgrade: PendingUpgrade | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export const UpgradeDialog: React.FC<UpgradeDialogProps> = ({
  open,
  onOpenChange,
  pendingUpgrade,
  onConfirm,
  onCancel,
}) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent className="sm:max-w-md">
      <AlertDialogHeader>
        <AlertDialogTitle className="text-lg">
          {pendingUpgrade?.plan.id === "free"
            ? "Downgrade to Free Plan"
            : "Confirm Plan Change"}
        </AlertDialogTitle>
        <AlertDialogDescription className="text-sm text-muted-foreground">
          {pendingUpgrade?.plan.id === "free"
            ? "You will be downgraded to the Free plan. Your subscription will be cancelled and you'll lose access to premium features at the end of your current billing period."
            : "You will be charged for the new plan. The price difference will be prorated based on your current billing cycle."}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel onClick={onCancel}>Cancel</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm}>
          {pendingUpgrade?.plan.id === "free"
            ? "Confirm Downgrade"
            : "Confirm Change"}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
